import React from 'react';
//import ReactDOM from 'react-dom';
import {InstantSearch} from 'react-instantsearch/dom';

import '../css/App.css';

import Search from './Search';
import Results from './Results';

import { withUrlSync } from '../urlSync';

const App = props => (
      <div>
        <InstantSearch
          appId="UCTC8I2YK5"
          apiKey="5a627c35eff2a5464beca452721d5301"
          indexName="para_tawny_v2"
          className="wrapper"
          searchState={props.searchState}
          createURL={props.createURL}
          onSearchStateChange={props.onSearchStateChange}
      >
        <div className="wrapper">
          <main className="content">
            <Search
              searchState={props.searchState}
              onSearchStateChange={props.onSearchStateChange}
            />
            <Results
              searchState={props.searchState}
              createURL={props.createURL}
              onSearchStateChange={props.onSearchStateChange} />
          </main>

        </div>

      </InstantSearch>
    </div>

  );


//export default App;
export default withUrlSync(App);



// WEBPACK FOOTER //
// ./src/components/App.js